import { DataBaseModelInterface } from '@solcre-org/core';
import { PortModel } from './port.model';
import { CargoTypeModel } from './cargo-type.model';
import { RateMeasurementUnit } from '../enums/rate-measurement-unit.enum';
import { RateTerms } from '../enums/rate-terms.enum';
import { portUriTemplate } from '../templates/portUriTemplate';
import { cargoTypeUriTemplate } from '../templates/cargoTypeUriTemplate';
import { CurrencyModel } from './currency.model';
import { currencyUriTemplate } from '../templates/currencyUriTemplate';

export class ClientRateModel implements DataBaseModelInterface {
  constructor(
    public id?: number,
    public client?: string, // Could be iri string or nested object
    public originPort?: string, // Usually when sending it's an IRI, when fetching, it's mapped to IRI or nested obj. It's stored as an IRI reference for components.
    public destinationPort?: string,
    public cargoType?: string,
    public measurementUnit?: RateMeasurementUnit | string,
    public amount?: string,
    public currency?: string,
    public terms?: RateTerms | string,
    public version?: number,
    public isActive?: boolean,
    public disabledAt?: string | null,
    public previousVersion?: ClientRateModel | number | string | null,
    public originPortDetails?: PortModel,
    public destinationPortDetails?: PortModel,
    public cargoTypeDetails?: CargoTypeModel,
    public currencyDetails?: CurrencyModel
  ) {}

  public fromJSON(json: any): ClientRateModel {
    if (json) {
      this.id = json.id;
      this.client = json.client;
      this.measurementUnit = json.measurementUnit;
      this.amount = json.amount;
      this.terms = json.terms;
      this.version = json.version;
      this.isActive = json.isActive;
      this.disabledAt = json.disabledAt ?? null;
      this.previousVersion = json.previousVersion ?? null;

      // Origin Port
      if (json.originPort && typeof json.originPort === 'object') {
        this.originPortDetails = new PortModel().fromJSON(json.originPort);
        this.originPort = portUriTemplate(this.originPortDetails.id?.toString() ?? '');
      } else {
        this.originPortDetails = undefined;
        this.originPort = json.originPort; 
      }

      // Destination Port
      if (json.destinationPort && typeof json.destinationPort === 'object') {
        this.destinationPortDetails = new PortModel().fromJSON(json.destinationPort);
        this.destinationPort = portUriTemplate(this.destinationPortDetails.id?.toString() ?? '');
      } else {
        this.destinationPortDetails = undefined;
        this.destinationPort = json.destinationPort;
      }

      // Cargo Type
      if (json.cargoType && typeof json.cargoType === 'object') {
        this.cargoTypeDetails = new CargoTypeModel().fromJSON(json.cargoType);
        this.cargoType = cargoTypeUriTemplate(this.cargoTypeDetails.id?.toString() ?? '');
      } else {
        this.cargoTypeDetails = undefined;
        this.cargoType = json.cargoType;
      }

      // Currency
      if (json.currency && typeof json.currency === 'object') {
        this.currencyDetails = new CurrencyModel().fromJSON(json.currency);
        this.currency = currencyUriTemplate(this.currencyDetails.id?.toString() ?? '');
      } else {
        this.currencyDetails = undefined;
        this.currency = json.currency;
      }
    }
    return this;
  }

  public fromJSONList(json: any): ClientRateModel[] {
    if (json) {
      return json.map((element: any) => new ClientRateModel().fromJSON(element));
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      client: this.client,
      originPort: this.originPort,
      destinationPort: this.destinationPort,
      cargoType: this.cargoType,
      measurementUnit: this.measurementUnit,
      currency: this.currency,
      terms: this.terms,
      amount: this.amount,
    };
  }

  public getId() {
    return this.id?.toString() ?? '';
  }

  public getReference() {
    return this.id ? `Rate #${this.id}` : '';
  }
}
